export const INITIAL_STATE = {
  notebook: {
    showLevelModal: true,
    levelData: null,
    protocolSection: null,
    sections: [],
    currentSection: null,
    notebookCollapsed: true
  },
};
